export const load = () => ({
	title: 'Energy Efficient Window Solutions',
	h1: 'Reduce Energy Use With Insulating Window Inserts',
	description:
		'Stop energy waste and reduce carbon emissions by insulating your windows through every season.',
	showTitle: true,
});
